exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-6977df65] {\n    padding: auto;\n    margin-left: 20px;\n    padding-top: 20px;\n}\n.my-content[data-v-6977df65] {\n    background: #fde2e2;\n}\n", ""]);

// exports
